import React, { useState, useEffect } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth"; // Import Firebase Auth
import AvatarDropdown from "./AvatarDropdown"; // Import the dropdown component
import "./CommunityHeader.css";

const CommunityHeader = ({ roomTitle, roomName }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [userPhoto, setUserPhoto] = useState(null); // State for user's profile picture
  const [userName, setUserName] = useState("User"); // State for user's name with default value

  // Fetch user's profile details from Firebase
  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUserPhoto(user.photoURL || "https://via.placeholder.com/150"); // Set photo or default placeholder
        setUserName(user.displayName || "User"); // Set name or default to "User"
      } else {
        setUserPhoto(null); // Reset photo if user logs out
        setUserName("User"); // Reset name if user logs out
      }
    });

    return () => unsubscribe(); // Cleanup listener on component unmount
  }, []);

  const handleMenuToggle = () => {
    setIsMenuOpen((prev) => !prev); // Toggle the dropdown menu
  };

  return (
    <header className="communityHeader">
      <div className="communityHeader-left">
        {/* Avatar with Click Event */}
        <div className="avatar-container">
          <img
            src={userPhoto} // Dynamic profile picture
            alt={`${userName}'s Avatar`} // Dynamically set alt text
            className="communityHeader-avatar"
            onClick={handleMenuToggle} // Open/close dropdown on click
          />
          {isMenuOpen && <AvatarDropdown />} {/* Render dropdown if menu is open */}
        </div>
        <div>
          <h1 className="communityHeader-title">{roomTitle}</h1>
          <p className="communityHeader-roomName">
            {roomName} - Hosted by {userName} {/* Show user name dynamically */}
          </p>
        </div>
      </div>

      <div className="communityHeader-right">
        <p className="communityHeader-nav">Community nav</p>
        <p className="communityHeader-chat">chat room</p>
      </div>
    </header>
  );
};

export default CommunityHeader;
